//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '@/api/api'

import firebase from 'firebase/app'
import 'firebase/storage'

export default {
    data() {
        return {
            newInputFieldName: '',
            newInputFieldType: null,
            newInputFieldPlaceholder: '',
            newInputFieldRequired: '',
            newInputFieldRadioOptions: [],
            inputFieldsDialog: false,
            newInputRadioOptions: [],
            newInputFieldTypeOptions: [
                {
                    label: 'Texto',
                    value: 'text',
                },
                {
                    label: 'Texto multilinea',
                    value: 'textarea',
                },
                {
                    label: 'Opcion multiple',
                    value: 'btngroup',
                },
            ],
            columns: [
                {
                    name: 'name',
                    label: 'Nombre',
                    field: 'name',
                    align: 'left',
                },
                {
                    name: 'type',
                    label: 'Tipo',
                    field: 'type',
                    align: 'left',
                },
                {
                    name: 'required',
                    label: 'Requerido',
                    align: 'left',
                },
                {
                    name: 'actions',
                    label: 'Acciones',
                    align: 'left',
                },
            ],
            data: [
                {
                    name: 'Nombre',
                    type: 'Texto',
                    required: true,
                },
                {
                    name: 'Comentarios especiales',
                    type: 'Area de texto',
                    required: false,
                },
                {
                    name: 'Fecha de entrega',
                    type: 'Opcion multiple',
                    required: true,
                },
            ],
            displayLoading: false,
            displayAlert: false,
            alertTitle: '',
            alertMessage: '',
            alertType: '',
        }
    },
    methods: {
        returnRadioOptions() {
            let options = []
            this.newInputFieldRadioOptions.forEach(op => {
                options.push({
                    label: op,
                    value: op,
                })
            })
            return options
        },
        cleanInputDialog() {
            ;(this.newInputFieldType = null), (this.inputFieldsDialog = false)
        },
        async addInputField() {
            this.displayLoading = true
            let db = firebase.firestore()
            let field = {
                    newInputFieldType: this.newInputFieldType,
                    newInputFieldName: this.newInputFieldName,
                    newInputFieldRadioOptions: this.newInputFieldRadioOptions,
                    newInputFieldRequired: this.newInputFieldRequired,
                    newInputFieldPlaceholder: this.newInputFieldPlaceholder,
                }
            let id = this.$route.params.restaurantId
            
            return db.collection('Restaurants').doc(id).update({
                inputFields: firebase.firestore.FieldValue.arrayUnion(field)
                })
                .then(() => {
                    this.displayLoading = false
                        this.alertTitle = 'Exito!'
                        this.alertMessage =
                            'Se ha actualizado el restaurante con exito'
                        this.alertType = 'success'
                        this.displayAlert = true
                        this.cleanInputDialog()
                    })
                .catch(error => {
                    console.log(error)
                    this.displayLoading = false
                    this.alertTitle = 'Error'
                    this.alertMessage = error
                    this.alertType = 'error'
                    this.displayAlert = true
                    this.cleanInputDialog()
                })
        },
    },
    watch: {
        newInputFieldType: function() {
            this.newInputFieldName = ''
            this.newInputFieldPlaceholder = ''
            this.newInputFieldRadioOptions = []
            this.newInputFieldRequired = null
        },
    },
}
